(function(globalScope) {
    var RESTAURANT_MOD = undefined;

    $(function() {
        if (restaurantModule && !RESTAURANT_MOD){
            RESTAURANT_MOD = new restaurantModule();
            RESTAURANT_MOD.init()
        }
    });

    // This function retrieves s3 parameters from our server API and appends them
    // to the upload form.
    function s3add(e, data) {
        if(!$.validateImage({name : data.files[0].name, size: data.files[0].size})) {
            Swal.fire({
                title: "Invalid File Format",
                text: "You can only upload images in JPG, JPEG, PNG, GIF, or BMP formats. Image size must be less than 50MB.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371"
            });            
        } else {
            processImageBeforeSubmit(data);
        }
    };

    //Image upload completed
    function onS3Done(e, data) {
        const result = data.result;
        var venueId = $('#venue-id').text().trim();
        var itemId = $('#menuItemId').length ? $('#menuItemId').html().trim() : venueId;
        var imageType = $('#menuItemId').length ? 'Menu Item' : 'Restaurant';
        $.post('/logItemImage', { itemId: itemId, url: result.bucketLink, imageType: imageType },
        function(imgUploaded) {
            //Reload the current view
            let url = new URL(window.location.href);
            url.searchParams.set('img_uploaded', true);
            saveLogRestaurant("Restaurant Image","Add Image","",result.bucketLink);
            window.location.href = url.href;
        })
        .catch(function(error) {
            Swal.fire({
                title: "Unable to Upload Image",
                text: "We had a problem saving this image.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371"
            });            
        })
    }

    function processImageBeforeSubmit(data){
        RESTAURANT_MOD.resizeImageShow(data)
    }

    globalScope.initS3FileUpload = function($fileInput) {
        var maxFileSize = 52428800; // 50MByte in bytes
        // The URL to your endpoint to register the uploaded file
        //var uploadUrl = '/uploadImages';
        $fileInput.fileupload({
            maxFileSize: maxFileSize,
            paramName: 'file',
            add: s3add,
            done: onS3Done,
            dataType: 'json',
            url: '/uploadRatingsImage',
            pasteZone: null,
            progressall: function (e, data) {
                const containerId = $(e.target).attr('data-container');
                let progress = parseInt(data.loaded / data.total * 100, 10);
                $(containerId).find('#progress .bar').show().css({
                        'width': progress + '%',
                        'text-align': 'right',
                        'color': 'white',
                        'font-size':'12px',
                        'padding-right': '10px',
                        'border-radius': '10px',
                        'border': '1px solid darkgreen',
                }) .text(`${progress}%`);
                if(progress == 100){
                    setTimeout(() => {$(containerId).find('#progress .bar').fadeOut()},200);
                }
            }
        });
    };

})(window)
